import { Dispatch, FC, SetStateAction, useMemo } from 'react';
import { GaugeChart, HexColor, LayoutCarousel } from '@silverfort/sf-components';
import { DaysRange } from '../../../types/DaysRange';
import { GaugeChartCarouselProps } from '../../../types/GaugeChartProps';
import { CHART_COLORS } from '@silverfort-nodelibs/common/utils/consts';

type ChartProps = GaugeChartCarouselProps & {
    id: DaysRange;
    label: string;
};

type ResourcesProtectionCoverageWidgetProps = {
    chartLabel: string;
    charts: Array<ChartProps>;
    loading: boolean;
    selectedDaysRange: DaysRange;
    setSelectedDaysRange: Dispatch<SetStateAction<DaysRange>>;
    widgetTitle: string;
};

const EMPTY_CHART_PROPS: GaugeChartCarouselProps = {
    endColor: CHART_COLORS[4] as HexColor,
    startColor: CHART_COLORS[1] as HexColor,
    value: 0
};

export const StaleResourcesWidget: FC<ResourcesProtectionCoverageWidgetProps> = ({
    chartLabel,
    charts,
    loading,
    selectedDaysRange,
    setSelectedDaysRange,
    widgetTitle
}) => {
    const options = useMemo(
        () =>
            charts.map((item) => ({
                title: item.label,
                value: item.id
            })),
        [charts]
    );

    const selectedChart = useMemo<GaugeChartCarouselProps>(() => {
        return charts.find((item) => item.id === selectedDaysRange) ?? EMPTY_CHART_PROPS;
    }, [charts, selectedDaysRange]);

    return (
        <LayoutCarousel
            contentClassName="flex flex-1 flex-col justify-center px-6"
            dropDownProps={{
                className: '[&]:w-[100px]',
                items: options,
                onChange: (value) => setSelectedDaysRange(value as DaysRange),
                selectedItems: selectedDaysRange,
                size: 'large',
                variant: 'trigger',
                width: '100px'
            }}
            pages={
                <GaugeChart
                    chartSize={200}
                    endColor={selectedChart.endColor}
                    isLoading={loading}
                    label={chartLabel}
                    startColor={selectedChart.startColor}
                    value={selectedChart.value}
                />
            }
            title={widgetTitle}
        />
    );
};
